import gql from 'graphql-tag';

export const PhotoDownloadDetails = gql`
  fragment PhotoDownloadDetails on PhotoDownload {
    id
    name
    status
    photos_count
    files(slice: { limit: 999 }) {
      total
      records {
        id
        url
      }
    }
  }
`;
